import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import lowerCase from 'lodash/lowerCase';

import { Box } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import { AssignmentRestrictionInput } from '@/types/schema';

import AssignmentRestriction from '../..';
import { DEFAULT_ASSIGNMENT_RESTRICTION } from '../../consts';
import { AssignmentRestrictionOverrides } from '../../types';

interface AssignmentRestrictionModalProps {
  assignmentRestriction: AssignmentRestrictionInput;
  onSubmit: (assignmentRestriction: AssignmentRestrictionInput) => void;
  onClose: () => void;
  contentName: string;
}

const OVERRIDES: AssignmentRestrictionOverrides = {
  settingsTabs: { direction: 'col', size: 'x-large' },
};

function AssignmentRestrictionModal(props: AssignmentRestrictionModalProps) {
  const { t } = useTranslation('AssignmentRestriction');
  const {
    assignmentRestriction = DEFAULT_ASSIGNMENT_RESTRICTION,
    onSubmit,
    contentName,
    onClose,
  } = props;
  const [restrictions, setRestrictions] = useState(assignmentRestriction);

  const onModalSubmit = useCallback(() => {
    onSubmit(restrictions);
    onClose();
  }, [onSubmit, restrictions, onClose]);

  return (
    <Modal
      action={{
        text: t('Common:Actions.SaveSettings'),
        onSubmit: onModalSubmit,
        discardText: t('Common:Cancel'),
      }}
      header={{
        title: t('Common:Form.AssignmentSettings'),
        description: t('AssignmentRestriction:AssignmentSettingsDescription', {
          contentName: lowerCase(contentName),
        }),
      }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      <Box className="flex flex-1 flex-col px-28 pb-128">
        <AssignmentRestriction
          assignmentRestriction={restrictions}
          className="flex-1 flex-wrap"
          contentName={contentName}
          overrides={OVERRIDES}
          onChange={setRestrictions}
        />
      </Box>
    </Modal>
  );
}

export default AssignmentRestrictionModal;
